export const compareObjects = (firstObject, secondObj): boolean => {
  return JSON.stringify(firstObject) === JSON.stringify(secondObj)
}
